import { Formik } from "formik";
import { Divider, Grid, TextField, Typography} from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { usePriceListStore } from "../../../hooks/usePriceListStore";
import { usePriceListProductStore } from "../../../hooks/usePriceListProductStore";
import { usePriceListBranchStore } from "../../../hooks/usePriceListBranchStore";
import { usePriceListCustomerStore } from "../../../hooks/usePriceListCustomerStore";
import { usePriceListSalesmanStore } from "../../../hooks/usePriceListSalesmanStore";
import { usePriceListSegmentStore } from "../../../hooks/usePriceListSegmentStore";

type Values = {
    id: number,
    code: string,
    name: string,
    description: string,
    validity_date: string,
    document_state: string,
    quantity_products: number,
    type: string,
    discounttype: string,
    max_desc_item: number,
    max_desc_global: number,
    products: any,
    idbranchoffices: any,
    idsalesman: any,
    idsegments: any,
    idcustomers: any,
    total: number,
    status: string,
}

const columns = [
    // { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'codesystem_product', label: 'Código', align:'center' },
    { type: 'text', field: 'name_product', label: 'Nombre', align:'center' },
    { type: 'text', field: 'price', label: 'Precio', align:'center' },
    // { type: 'text', field: 'cost', label: 'Costo', align:'center' },
    // { type: 'text', field: 'quantity', label: 'Cantidad', align:'center' },
    // { type: 'text', field: 'subtotal', label: 'Subtotal', align:'center', format:(row) => row.subtotal ? row.subtotal : '0' },
    // { type: 'detail', field: 'detail', label: 'Detalles', align:'center' },
];

const columnsbranch = [
    { type: 'text', field: 'branchOffice', label: 'Sucursal', align:'center' },
    { type: 'text', field: 'district', label: 'Distrito', align:'center' },
    { type: 'text', field: 'officetype', label: 'Tipo', align:'center' },
];
const columnssalesman = [
    { type: 'text', field: 'rut_salesman', label: 'Rut', align:'center' },
    { type: 'text', field: 'name_salesman', label: 'Vendedor', align:'center' },
    { type: 'text', field: 'email_salesman', label: 'Correo', align:'center' },
    { type: 'text', field: 'phone_salesman', label: 'Teléfono', align:'center' },
];
const columnssegment = [
    { type: 'text', field: 'segment', label: 'Segmento', align:'center' },
    { type: 'text', field: 'description', label: 'Descripción', align:'center' },
];
const columnscustomer = [
    { type: 'text', field: 'rut_customer', label: 'Rut', align:'center' },
    { type: 'text', field: 'name_customer', label: 'Cliente', align:'center' },
    { type: 'text', field: 'email_customer', label: 'Correo', align:'center' },
    { type: 'text', field: 'phone_customer', label: 'Teléfono', align:'center' },
];

export const DuplicateListModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, listSelected, homelist, clearState } = props;

    const { action, duplicatePriceList } = usePriceListStore();
    const { getPriceListProduct, priceListProduct } = usePriceListProductStore();
    const { getPriceListBranchoffice } = usePriceListBranchStore();
    const { getPriceListCustomers } = usePriceListCustomerStore();
    const { getPriceListSalesman } = usePriceListSalesmanStore();
    const { getPriceListSegments } = usePriceListSegmentStore();

    const [loading, setLoading] = useState<boolean>(false);
    const [loadingdata, setLoadingdata] = useState<boolean>(false);
    const [loadingProducts, setLoadingProducts] = useState<boolean>(false);
    const [branches, setBranches] = useState<any>([]);
    const [customers, setCustomers] = useState<any>([]);
    const [salesman, setSalesman] = useState<any>([]);
    const [segments, setSegments] = useState<any>([]);
    const [dataDetails, setDataDetails] = useState<any>([]);
    const [showdetails, setshowdeatils] = useState<boolean>(true);
    const [showproducts, setshowproducts] = useState<boolean>(false);
    const [showdetailtypes, setshowdetailtypes] = useState<boolean>(false);
    const [data, setData] = useState<Values>({
        id: listSelected ? listSelected.id :'',
        code: '',
        name: '',
        description: listSelected ? listSelected.description :'',
        validity_date: listSelected ? listSelected.validity_date :'',
        document_state: listSelected ? listSelected.document_state :'1',
        quantity_products: listSelected ? listSelected.quantity_products : 1,
        type: listSelected ? listSelected.type :'1',
        discounttype: listSelected ? listSelected.discounttype :'3',
        max_desc_item: listSelected ? listSelected.max_desc_item :'',
        max_desc_global: listSelected ? listSelected.max_desc_global :'',
        products: listSelected ? listSelected.products :'',
        idbranchoffices: listSelected ? listSelected.idbranchoffices :'',
        idsalesman: listSelected ? listSelected.idsalesman :'',
        idsegments: listSelected ? listSelected.idsegments :'',
        idcustomers: listSelected ? listSelected.idcustomers :'',
        total: listSelected ? listSelected.total : 0,
        status: listSelected ? listSelected.status :'1',
    });

    const getPriceListProductApi = async(search='') => {
        try {
            setLoadingProducts(true);
            await getPriceListProduct({search:search, idpricelist:listSelected.id});
            setLoadingProducts(false);
           
        } catch (error) {
            setLoadingProducts(false);
        }
    }
    const getPriceListBranchofficeApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getPriceListBranchoffice({search:search, idpricelist:listSelected.id});
            if(!response){
                setBranches([]);
                setLoadingdata(false);
                return false;
            }else{
                setBranches(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getPriceListSalesmanApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getPriceListSalesman({search:search, idpricelist:listSelected.id});
            if(!response){
                setSalesman([]);
                setLoadingdata(false);
                return false;
            }else{
                setSalesman(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getPriceListSegmentsApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getPriceListSegments({search:search, idpricelist:listSelected.id});
            if(!response){
                setSegments([]);
                setLoadingdata(false);
                return false;
            }else{
                setSegments(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getPriceListCustomersApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getPriceListCustomers({search:search, idpricelist:listSelected.id});
            if(!response){
                setCustomers([]);
                setLoadingdata(false);
                return false;
            }else{
                setCustomers(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.code) errors.code = "el campo es requerido";
        if(!values.name) errors.name = "el campo es requerido";
        return errors;
    }

    const showDetails = () =>{
        setshowdeatils(!showdetails);
    }

    const typeList = (type) => {
        switch (type) {
            case '1':
                return 'General'
            case '2':
                return 'Por sucursal'
            case '3':
                return 'Por vendedor'
            case '4':
                return 'Por segmento'
            case '5':
                return 'Por cliente'
        }
    }

    const showProducts = () =>{
        if(!showproducts) getPriceListProductApi();
        setshowproducts(!showproducts);
    }

    const showDetailTypes = (type) =>{
        if(!showdetailtypes){
            switch (type) {
                case '2':
                    getPriceListBranchofficeApi();
                    break;
                case '3':
                    getPriceListSalesmanApi();
                    break;
                case '4':
                    getPriceListSegmentsApi();
                    break;
                case '5':
                    getPriceListCustomersApi();
                    break;
                default:
                    break;
            }
        }
        setshowdetailtypes(!showdetailtypes);
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        const formData = {
            code: values.code,
            name: values.name,
            idpricelist: listSelected.id,
        }

        if(listSelected){
            const response:any = await duplicatePriceList(formData);
            if(response){
                homelist && homelist();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="lg" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' }}}>
            <ModalHeader
                text={'Duplicar lista'}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'0px 20px 20px 20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                id="code"
                                                type="text" 
                                                name="code"
                                                fullWidth
                                                size="small"
                                                value={values.code}
                                                onChange={handleChange}
                                                error={errors.code && touched.code ? true : false}
                                                helperText={errors.code && touched.code ? errors.code : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                                placeholder={'código'}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                id="name"
                                                type="text" 
                                                name="name"
                                                fullWidth
                                                size="small"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={errors.name && touched.name ? true : false}
                                                helperText={errors.name && touched.name ? errors.name : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                                placeholder={'nombre'}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            {`Esta cerca de duplicar la lista: `} <b>{listSelected?.name}.</b>
                                            <a
                                                onClick={showDetails}
                                                style={{
                                                    marginLeft: '20px',
                                                    color: 'blue',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {showdetails ? `ocultar detalles` : `ver detalles`}
                                            </a>
                                        </Grid>
                                        {
                                            showdetails && (
                                                <>
                                                <Grid item container xs={12}>
                                                    <Grid item xs={12} md={6}>
                                                        <Grid display='flex' alignItems='center'>
                                                            <Typography variant="subtitle1" sx={{width:'200px'}}>Fecha de vigencia</Typography>
                                                            <Typography variant="body1" sx={{width:'200px'}}>{values.validity_date}</Typography>
                                                        </Grid>
                                                        {/* <Grid display='flex' alignItems='center'>
                                                            <Typography variant="subtitle1" sx={{width:'200px'}}>Tipo de lista</Typography>
                                                            <Typography variant="body1" sx={{width:'200px'}}>{typeList(values.type)}</Typography>
                                                        </Grid> */}
                                                        <Grid display='flex' alignItems='center'>
                                                            <Typography variant="subtitle1" sx={{width:'200px'}}>Máx. desc. por item</Typography>
                                                            <Typography variant="body1" sx={{width:'200px'}}>{values.max_desc_item ?? '---'}</Typography>
                                                        </Grid>
                                                        <Grid display='flex' alignItems='center'>
                                                            <Typography variant="subtitle1" sx={{width:'200px'}}>Estado</Typography>
                                                            <Typography variant="body1" sx={{width:'200px'}}>{values.status == '0' ? 'Inactivo' : (values.status == '1' ? 'Activo' : 'Eliminado')}</Typography>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        {/* <Grid display='flex' alignItems='center'>
                                                            <Typography variant="subtitle1" sx={{width:'200px'}}>Cantidad productos</Typography>
                                                            <Typography variant="body1" sx={{width:'200px'}}>{values.quantity_products}</Typography>
                                                        </Grid> */}
                                                        <Grid display='flex' alignItems='center'>
                                                            <Typography variant="subtitle1" sx={{width:'200px'}}>Tipo de descuento</Typography>
                                                            <Typography variant="body1" sx={{width:'200px'}}>{values.discounttype == '1' ? '$' : (values.discounttype == '2' ? '%' : 'Sin descuento')}</Typography>
                                                        </Grid>
                                                        <Grid display='flex' alignItems='center'>
                                                            <Typography variant="subtitle1" sx={{width:'200px'}}>Max. desc. global</Typography>
                                                            <Typography variant="body1" sx={{width:'200px'}}>{values.max_desc_global ?? '---'}</Typography>
                                                        </Grid>
                                                        {
                                                            values.type == '1' && (
                                                                <Grid display='flex' alignItems='center'>
                                                                    <Typography variant="subtitle1" sx={{width:'200px'}}>Tipo lista</Typography>
                                                                    <Typography variant="body1" sx={{width:'200px'}}>{typeList(values.type)}</Typography>
                                                                </Grid>
                                                            )
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    {`La lista contiene ${values.quantity_products} productos asignados.`}
                                                    <a
                                                        onClick={showProducts}
                                                        style={{
                                                            marginLeft: '20px',
                                                            color: 'blue',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        {showproducts ? `ocultar productos asignados` : `ver productos asignados`}
                                                    </a>
                                                </Grid>
                                                {
                                                    showproducts && (
                                                        <Grid item xs={12}>
                                                            <CustomTable
                                                                disabled_title
                                                                columns={columns}
                                                                loading={loadingProducts}
                                                                rows={priceListProduct || []}
                                                                onRowClick={() => {}}
                                                                RowsPerPage={5}
                                                                dense
                                                            />
                                                        </Grid>
                                                    )
                                                }
                                                {
                                                    values.type != '1' && (
                                                        <Grid item xs={12}>
                                                            {`El tipo de lista es ${typeList(values.type)}.`}
                                                            <a
                                                                onClick={()=>showDetailTypes(values.type)}
                                                                style={{
                                                                    marginLeft: '20px',
                                                                    color: 'blue',
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                {showdetailtypes ? `ocultar asignaciones` : `ver asignaciones`}
                                                            </a>
                                                        </Grid>
                                                    )
                                                }
                                                {
                                                    showdetailtypes && (
                                                        <Grid item xs={12}>
                                                            {
                                                                values.type == '2' && (
                                                                    <CustomTable
                                                                        disabled_title
                                                                        columns={columnsbranch}
                                                                        loading={loadingdata}
                                                                        rows={branches || []}
                                                                        onRowClick={() => {}}
                                                                        RowsPerPage={5}
                                                                        dense
                                                                    />
                                                                )
                                                            }
                                                            {
                                                                values.type == '3' && (
                                                                    <CustomTable
                                                                        disabled_title
                                                                        columns={columnssalesman}
                                                                        loading={loadingdata}
                                                                        rows={salesman || []}
                                                                        onRowClick={() => {}}
                                                                        RowsPerPage={5}
                                                                        dense
                                                                    />
                                                                )
                                                            }
                                                            {
                                                                values.type == '4' && (
                                                                    <CustomTable
                                                                        disabled_title
                                                                        columns={columnssegment}
                                                                        loading={loadingdata}
                                                                        rows={segments || []}
                                                                        onRowClick={() => {}}
                                                                        RowsPerPage={5}
                                                                        dense
                                                                    />
                                                                )
                                                            }
                                                            {
                                                                values.type == '5' && (
                                                                    <CustomTable
                                                                        disabled_title
                                                                        columns={columnscustomer}
                                                                        loading={loadingdata}
                                                                        rows={customers || []}
                                                                        onRowClick={() => {}}
                                                                        RowsPerPage={5}
                                                                        dense
                                                                    />
                                                                )
                                                            }
                                                            
                                                        </Grid>
                                                    )
                                                }
                                                </>
                                            )
                                        }
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action != 'detail' && (
                                        <ModalFooter 
                                            buttonType="submit"
                                            confirmText={'Duplicar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loading}
                                            clearState={clearState}
                                        />
                                    )
                                }
                                
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}